// Wrapper around our Typography Header
import withTypography from './withTypography'
import Header from '../components/ui/Typography/Header'

export default withTypography(Header)
